import React from "react";
import { motion } from "framer-motion";

const incubationCenters = [
  {
    icon: "https://cdn.lordicon.com/kndkiwmf.json", // Office Building
    title: "TechHub Innovation",
    description: "Focused on SaaS, AI, and enterprise software startups.",
    points: [
      "24/7 workspace access",
      "Technical mentorship",
      "Cloud credits worth $100,000",
    ],
  },
  {
    icon: "https://cdn.lordicon.com/egmlnyku.json", // Green/eco theme
    title: "GreenTech Accelerator",
    description: "Supporting sustainability and clean technology ventures.",
    points: [
      "Sustainable business consulting",
      "Industry connections",
      "$50,000 seed funding opportunity",
    ],
  },
  {
    icon: "https://cdn.lordicon.com/tdtlrbly.json", // Healthcare
    title: "HealthTech Ventures",
    description: "Dedicated to healthcare innovation and medical technology.",
    points: [
      "Regulatory guidance",
      "Clinical trial support",
      "Healthcare investor network",
    ],
  },
];

const IncubationSection = () => {
  return (
    <section className="bg-white px-4 py-8 md:py-10 lg:py-12">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
          Incubation Centers
        </h2>
        <p className="text-gray-600 text-sm md:text-base mb-10">
          Our partner incubation centers provide resources, mentorship, and
          workspace for startups.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {incubationCenters.map((center, index) => (
            <motion.div
              key={index}
              className="bg-white rounded-xl shadow-md p-6 flex flex-col justify-between items-start transition-all hover:shadow-xl"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="flex items-center mb-4">
                <div className="p-2 rounded-full mr-3 border border-gray-200 bg-gray-50">
                  <lord-icon
                    src={center.icon}
                    trigger="loop"
                    colors="primary:#0d6efd,secondary:#08a88a"
                    style={{ width: "40px", height: "40px" }}
                  ></lord-icon>
                </div>
                <div>
                  <h3 className="text-md font-semibold text-gray-900">
                    {center.title}
                  </h3>
                  <p className="text-sm text-gray-600 mt-1">
                    {center.description}
                  </p>
                </div>
              </div>

              <ul className="text-sm text-gray-700 list-inside">
                {center.points.map((point, idx) => (
                  <li key={idx} className="flex items-start mb-1">
                    <span className="text-blue-600 mr-2">✓</span> {point}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IncubationSection;
